import { init_clarity } from "~/assets/js/plugins/clarity";

export default defineNuxtPlugin(nuxtApp => {
  init_clarity();
});
